import React, { FC } from 'react';
import _ from 'lodash';
import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import Header from '@components/Header';
import { PAGE_NAMES } from '@components/Hooks/useMarketplaceHeaderBi';

const TemplateGalleryPageHeader: FC = () => {
  const { sessionId } = useBiSessionContext();

  return (
    <Header
      onClick={() => {}}
      pageName={PAGE_NAMES.templates}
      sessionId={sessionId}
    />
  );
};

export default TemplateGalleryPageHeader;
